import { ApiDeposit, ApiLoan } from 'api/rtk-api'

import { Space } from '../../../components/core-v2'
import { AssetCard } from '../../../components/core-v2/molecules/asset-card'

export type CashInstrumentsViewProps = {
  instruments: ApiDeposit[] | ApiLoan[]
  onSelectInstrument: (instId: string) => void
  selectedInstrument?: ApiDeposit | ApiLoan
}

const CashInstrumentsView = (props: CashInstrumentsViewProps) => {
  const { instruments } = props
  const { selectedInstrument } = props
  const { onSelectInstrument } = props

  return (
    <Space mt={3}>
      <ul>
        {instruments.map(inst => (
          <AssetCard
            key={inst.instrumentId}
            assetId={inst.instrumentId}
            assetName={inst.name}
            isInUse={false}
            isSelected={selectedInstrument && inst.instrumentId === selectedInstrument.instrumentId}
            onClickAsset={() => onSelectInstrument(inst.instrumentId)}
          />
        ))}
      </ul>
    </Space>
  )
}

export default CashInstrumentsView
